declare namespace $ {

	type $mol_number__Inc_shm_hitalama_settings_1 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Inc'] >
	>
	type $mol_number__Dec_shm_hitalama_settings_2 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Dec'] >
	>
	type $mol_number__value_shm_hitalama_settings_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['stick_px'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_labeler__title_shm_hitalama_settings_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_settings_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['Stick'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_number__Inc_shm_hitalama_settings_6 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Inc'] >
	>
	type $mol_number__Dec_shm_hitalama_settings_7 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Dec'] >
	>
	type $mol_number__value_shm_hitalama_settings_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['widget_float_resizer_size'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_labeler__title_shm_hitalama_settings_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_settings_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['Widget_float_resizer_size'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_check_box__title_shm_hitalama_settings_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_settings_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['dragger_keep_size'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_labeler__title_shm_hitalama_settings_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_settings_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['Dragger_keep_size'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_number__Inc_shm_hitalama_settings_15 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Inc'] >
	>
	type $mol_number__Dec_shm_hitalama_settings_16 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Dec'] >
	>
	type $mol_number__value_shm_hitalama_settings_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['widget_keyboard_move_step_px'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_labeler__title_shm_hitalama_settings_18 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_settings_19 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['Widget_keyboard_move_step'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $shm_hitalama_settings_agent_string__input_name_shm_hitalama_settings_20 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_settings_agent_string['input_name'] >
	>
	type $shm_hitalama_settings_agent_string__value_shm_hitalama_settings_21 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['agent_url'] >
		,
		ReturnType< $shm_hitalama_settings_agent_string['value'] >
	>
	type $mol_labeler__title_shm_hitalama_settings_22 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_settings_23 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['Agent_url'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $shm_hitalama_settings_agent_password__input_name_shm_hitalama_settings_24 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_settings_agent_password['input_name'] >
	>
	type $shm_hitalama_settings_agent_password__value_shm_hitalama_settings_25 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['agent_token'] >
		,
		ReturnType< $shm_hitalama_settings_agent_password['value'] >
	>
	type $mol_labeler__title_shm_hitalama_settings_26 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_settings_27 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['Agent_token'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_select__dictionary_shm_hitalama_settings_28 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['microphones'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_shm_hitalama_settings_29 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['mic'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_labeler__title_shm_hitalama_settings_30 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_settings_31 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['Mic'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_check_box__checked_shm_hitalama_settings_32 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['overlayed_map_enabled'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_link__title_shm_hitalama_settings_33 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_shm_hitalama_settings_34 = $mol_type_enforce<
		({ 
			'settings': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_view__sub_shm_hitalama_settings_35 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__title_shm_hitalama_settings_36 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_shm_hitalama_settings_37 = $mol_type_enforce<
		({ 
			'settings': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_shm_hitalama_settings_38 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_shm_hitalama_settings_39 = $mol_type_enforce<
		({ 
			'settings': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_shm_hitalama_settings_40 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_shm_hitalama_settings_41 = $mol_type_enforce<
		({ 
			'settings': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_shm_hitalama_settings_42 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_shm_hitalama_settings_43 = $mol_type_enforce<
		({ 
			'settings': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_view__sub_shm_hitalama_settings_44 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_labeler__title_shm_hitalama_settings_45 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_settings_46 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['Templates_links'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_labeler__title_shm_hitalama_settings_47 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_settings_48 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['Maps_transfer'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_link__title_shm_hitalama_settings_49 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_shm_hitalama_settings_50 = $mol_type_enforce<
		({ 
			'settings': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_page__title_shm_hitalama_settings_51 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_shm_hitalama_settings_52 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_string__value_shm_hitalama_settings_53 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['slideshow_mode_key'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_shm_hitalama_settings_54 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_settings_55 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_string__value_shm_hitalama_settings_56 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['fullscreen_disable_key'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_shm_hitalama_settings_57 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_settings_58 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_string__value_shm_hitalama_settings_59 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['drag_mode_key'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_shm_hitalama_settings_60 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_settings_61 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_string__value_shm_hitalama_settings_62 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['drawing_mode_key'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_shm_hitalama_settings_63 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_settings_64 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_page__title_shm_hitalama_settings_65 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_shm_hitalama_settings_66 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $shm_hitalama_map_book__entity_shm_hitalama_settings_67 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['template_map'] >
		,
		ReturnType< $shm_hitalama_map_book['entity'] >
	>
	type $shm_hitalama_map_book__entity_shm_hitalama_settings_68 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['template_map'] >
		,
		ReturnType< $shm_hitalama_map_book['entity'] >
	>
	type $shm_hitalama_map_book__entity_shm_hitalama_settings_69 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['template_map'] >
		,
		ReturnType< $shm_hitalama_map_book['entity'] >
	>
	type $shm_hitalama_map_book__entity_shm_hitalama_settings_70 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['template_map'] >
		,
		ReturnType< $shm_hitalama_map_book['entity'] >
	>
	type $shm_hitalama_map_book__entity_shm_hitalama_settings_71 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['overlayed_map'] >
		,
		ReturnType< $shm_hitalama_map_book['entity'] >
	>
	type $mol_page__title_shm_hitalama_settings_72 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_shm_hitalama_settings_73 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['selfhosted_tauri_content'] >
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_text__text_shm_hitalama_settings_74 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['tauri_port_conflict_message'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_number__Inc_shm_hitalama_settings_75 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Inc'] >
	>
	type $mol_number__Dec_shm_hitalama_settings_76 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Dec'] >
	>
	type $mol_number__value_shm_hitalama_settings_77 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['tauri_port'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_labeler__title_shm_hitalama_settings_78 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_settings_79 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['Tauri_port'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_string__value_shm_hitalama_settings_80 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['tauri_domain'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_shm_hitalama_settings_81 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_settings_82 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['Tauri_domain'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_string__value_shm_hitalama_settings_83 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['tauri_master'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_shm_hitalama_settings_84 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_settings_85 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['Tauri_master'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_check_box__title_shm_hitalama_settings_86 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_settings_87 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['tauri_tunnel_enabled'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_string__value_shm_hitalama_settings_88 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['tauri_ssh_host'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_shm_hitalama_settings_89 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_settings_90 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['Tauri_ssh_host'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_string__value_shm_hitalama_settings_91 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['tauri_ssh_user'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_shm_hitalama_settings_92 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_settings_93 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['Tauri_ssh_user'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_number__Inc_shm_hitalama_settings_94 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Inc'] >
	>
	type $mol_number__Dec_shm_hitalama_settings_95 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Dec'] >
	>
	type $mol_number__value_shm_hitalama_settings_96 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['tauri_ssh_port'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_labeler__title_shm_hitalama_settings_97 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_settings_98 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['Tauri_ssh_port'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_number__Inc_shm_hitalama_settings_99 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Inc'] >
	>
	type $mol_number__Dec_shm_hitalama_settings_100 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Dec'] >
	>
	type $mol_number__value_shm_hitalama_settings_101 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['tauri_remote_port'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_labeler__title_shm_hitalama_settings_102 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_settings_103 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['Tauri_remote_port'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_string__value_shm_hitalama_settings_104 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['tauri_ssh_key'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_shm_hitalama_settings_105 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_settings_106 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['Tauri_ssh_key'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_button_major__title_shm_hitalama_settings_107 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_hitalama_settings_108 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['tauri_save'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_text__text_shm_hitalama_settings_109 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['tauri_save_message'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_book2_catalog__param_shm_hitalama_settings_110 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_book2_catalog['param'] >
	>
	type $mol_book2_catalog__spreads_shm_hitalama_settings_111 = $mol_type_enforce<
		({ 
			'hotkeys': ReturnType< $shm_hitalama_settings['Hotkeys'] >,
			'templates_js': ReturnType< $shm_hitalama_settings['Templates_js'] >,
			'templates_tsx': ReturnType< $shm_hitalama_settings['Templates_tsx'] >,
			'templates_sql': ReturnType< $shm_hitalama_settings['Templates_sql'] >,
			'templates_commands': ReturnType< $shm_hitalama_settings['Templates_commands'] >,
			'overlayed_map': ReturnType< $shm_hitalama_settings['Overlayed_map'] >,
			'selfhosted_tauri': ReturnType< $shm_hitalama_settings['Selfhosted_tauri'] >,
		}) 
		,
		ReturnType< $mol_book2_catalog['spreads'] >
	>
	type $mol_view__sub_shm_hitalama_settings_112 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings['selfhosted_tauri_config_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__title_shm_hitalama_settings_113 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_shm_hitalama_settings_114 = $mol_type_enforce<
		({ 
			'settings': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	export class $shm_hitalama_settings extends $mol_book2 {
		stick_px( next?: number ): number
		Stick( ): $mol_number
		Stick_label( ): $mol_labeler
		widget_float_resizer_size( next?: number ): number
		Widget_float_resizer_size( ): $mol_number
		Widget_float_resizer_size_label( ): $mol_labeler
		dragger_keep_size( next?: boolean ): boolean
		Dragger_keep_size( ): $mol_check_box
		Dragger_keep_size_label( ): $mol_labeler
		widget_keyboard_move_step_px( next?: number ): number
		Widget_keyboard_move_step( ): $mol_number
		Widget_keyboard_move_step_label( ): $mol_labeler
		agent_url( next?: string ): string
		Agent_url( ): $shm_hitalama_settings_agent_string
		Agent_url_label( ): $mol_labeler
		agent_token( next?: string ): string
		Agent_token( ): $shm_hitalama_settings_agent_password
		Agent_token_label( ): $mol_labeler
		microphones( ): Record<string, any>
		mic( next?: string ): string
		Mic( ): $mol_select
		Mic_label( ): $mol_labeler
		overlayed_map_enabled( next?: boolean ): boolean
		Overlayed_map_enabled( ): $mol_check_box
		Overlayed_map_link( ): $mol_link
		Overlayed_map_controls( ): $mol_view
		Template_js_link( ): $mol_link
		Template_tsx_link( ): $mol_link
		Template_sql_link( ): $mol_link
		Template_commands_link( ): $mol_link
		Templates_links( ): $mol_view
		Templates_label( ): $mol_labeler
		Maps_transfer( ): $shm_hitalama_settings_transfer
		Maps_transfer_label( ): $mol_labeler
		Hotkeys_link( ): $mol_link
		Main( ): $mol_page
		spread_current( ): ReturnType< ReturnType< $shm_hitalama_settings['Catalog'] >['spread_current'] >
		slideshow_mode_key( next?: string ): string
		Slideshow_mode( ): $mol_string
		Slideshow_mode_label( ): $mol_labeler
		fullscreen_disable_key( next?: string ): string
		Fullscreen_disable( ): $mol_string
		Fullscreen_disable_label( ): $mol_labeler
		drag_mode_key( next?: string ): string
		Drag_mode( ): $mol_string
		Drag_mode_label( ): $mol_labeler
		drawing_mode_key( next?: string ): string
		Drawing_mode( ): $mol_string
		Drawing_mode_label( ): $mol_labeler
		Hotkeys( ): $mol_page
		template_map( id: any): any
		Templates_js( ): $shm_hitalama_map_book
		Templates_tsx( ): $shm_hitalama_map_book
		Templates_sql( ): $shm_hitalama_map_book
		Templates_commands( ): $shm_hitalama_map_book
		overlayed_map( ): any
		Overlayed_map( ): $shm_hitalama_map_book
		selfhosted_tauri_content( ): readonly(any)[]
		Selfhosted_tauri( ): $mol_page
		tauri_port_conflict_message( ): string
		Tauri_port_conflict_message( ): $mol_text
		tauri_port_conflict_message_visible( ): readonly(any)[]
		tauri_port( next?: number ): number
		Tauri_port( ): $mol_number
		Tauri_port_label( ): $mol_labeler
		tauri_domain( next?: string ): string
		Tauri_domain( ): $mol_string
		Tauri_domain_label( ): $mol_labeler
		tauri_master( next?: string ): string
		Tauri_master( ): $mol_string
		Tauri_master_label( ): $mol_labeler
		tauri_tunnel_enabled( next?: boolean ): boolean
		Tauri_tunnel_enabled( ): $mol_check_box
		tauri_ssh_host( next?: string ): string
		Tauri_ssh_host( ): $mol_string
		Tauri_ssh_host_label( ): $mol_labeler
		tauri_ssh_user( next?: string ): string
		Tauri_ssh_user( ): $mol_string
		Tauri_ssh_user_label( ): $mol_labeler
		tauri_ssh_port( next?: number ): number
		Tauri_ssh_port( ): $mol_number
		Tauri_ssh_port_label( ): $mol_labeler
		tauri_remote_port( next?: number ): number
		Tauri_remote_port( ): $mol_number
		Tauri_remote_port_label( ): $mol_labeler
		tauri_ssh_key( next?: string ): string
		Tauri_ssh_key( ): $mol_string
		Tauri_ssh_key_label( ): $mol_labeler
		tauri_save( next?: any ): any
		Tauri_save( ): $mol_button_major
		tauri_save_message( next?: string ): string
		Tauri_save_message( ): $mol_text
		title( ): string
		pages( ): readonly(any)[]
		Catalog( ): $mol_book2_catalog
		Selfhosted_tauri_config( ): $mol_view
		selfhosted_tauri_config_content( ): readonly(any)[]
		Selfhosted_tauri_link( ): $mol_link
		selfhosted_tauri_link( ): any
	}
	
	export class $shm_hitalama_settings_agent_string extends $mol_string {
		autocomplete_locked( next?: boolean ): boolean
		autocomplete_unlock( next?: any ): any
		input_name( ): string
		field( ): ({ 
			'autocomplete': string,
			'readOnly': ReturnType< $shm_hitalama_settings_agent_string['autocomplete_locked'] >,
		})  & ReturnType< $mol_string['field'] >
		attr( ): ({ 
			'autocomplete': string,
			'name': ReturnType< $shm_hitalama_settings_agent_string['input_name'] >,
			'readonly': ReturnType< $shm_hitalama_settings_agent_string['autocomplete_locked'] >,
			'aria-autocomplete': string,
		})  & ReturnType< $mol_string['attr'] >
		event( ): ({ 
			focus( next?: ReturnType< $shm_hitalama_settings_agent_string['autocomplete_unlock'] > ): ReturnType< $shm_hitalama_settings_agent_string['autocomplete_unlock'] >,
		})  & ReturnType< $mol_string['event'] >
	}
	
	type $shm_hitalama_settings_agent_string__type_shm_hitalama_settings_agent_password_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent_password['type'] >
		,
		ReturnType< $shm_hitalama_settings_agent_string['type'] >
	>
	type $shm_hitalama_settings_agent_string__hint_shm_hitalama_settings_agent_password_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent_password['hint'] >
		,
		ReturnType< $shm_hitalama_settings_agent_string['hint'] >
	>
	type $shm_hitalama_settings_agent_string__input_name_shm_hitalama_settings_agent_password_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent_password['input_name'] >
		,
		ReturnType< $shm_hitalama_settings_agent_string['input_name'] >
	>
	type $shm_hitalama_settings_agent_string__value_shm_hitalama_settings_agent_password_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent_password['value'] >
		,
		ReturnType< $shm_hitalama_settings_agent_string['value'] >
	>
	type $shm_hitalama_settings_agent_string__submit_shm_hitalama_settings_agent_password_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent_password['submit'] >
		,
		ReturnType< $shm_hitalama_settings_agent_string['submit'] >
	>
	type $shm_hitalama_settings_agent_string__enabled_shm_hitalama_settings_agent_password_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent_password['enabled'] >
		,
		ReturnType< $shm_hitalama_settings_agent_string['enabled'] >
	>
	export class $shm_hitalama_settings_agent_password extends $mol_password {
		hint( ): string
		value( next?: string ): string
		submit( next?: any ): any
		enabled( ): boolean
		input_name( ): string
		Pass( ): $shm_hitalama_settings_agent_string
	}
	
}

//# sourceMappingURL=settings.view.tree.d.ts.map